<script>

export default {
  computed: {
    style() {
      if (this.x == null || this.y == null) {
        return {};
      }
      return {
        top: `${this.y}px`,
        left: `${this.x}px`,
        position: 'absolute'
      };
    }
  },
  props: {
    x: { type: Number },
    y: { type: Number }
  }
};

</script>
